import { IChildProp } from '@intelligence/components/Form/type';

// 下载弹窗的配置
// 注意key如果发生修改，convertDownloadPopupParams方法中映射key要同步修改
const MOBILE_UNIVERSAL_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'mobileSource',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    isShowOneText: true,
    children: [
      {
        enumKey: 'ogdb_mobile',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        condition: 'additionalFields:businessType:mobile-databrain',
        defaultSelectCondition: 'additionalFields:source:[]ogdb',
      },
      {
        enumKey: 'appannie_mobile',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        defaultSelectCondition: 'additionalFields:source:[]appannie',
      },
      {
        enumKey: 'sensortower_mobile',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        condition:
          '!additionalFields:businessType:mobile-rpd&&!additionalFields:businessType:mobile-retention',
        defaultSelectCondition: 'additionalFields:source:[]sensortower',
      },
    ],
  },
  {
    enumKey: 'metrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    isShowOneText: true,
    children: [
      {
        enumKey: 'activeUsers_appannie',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:metrics:[]dau',
      },
      {
        enumKey: 'revenue_appannie',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:metrics:[]revenue',
      },
      {
        enumKey: 'arpu_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:metrics:[]arpu',
      },
      {
        enumKey: 'downloads_appannie',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:metrics:[]download',
      },
      {
        enumKey: 'rpd_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-rpd',
      },
      {
        enumKey: 'cumulativeRevenue_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-rpd',
      },
      {
        enumKey: 'cumulativeDownloads_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-rpd',
      },
      {
        enumKey: 'd2_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-retention',
      },
      {
        enumKey: 'd3_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-retention',
      },
      {
        enumKey: 'd7_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-retention',
      },
      {
        enumKey: 'd15_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-retention',
      },
      {
        enumKey: 'd31_mobile',
        enumTargetType: 'metric',
        isNoIcon: true,
        isDefault: true,
        condition: 'additionalFields:businessType:mobile-retention',
      },
    ],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'hasCompany',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasGenre',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasRelease',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasGameEngine',
        enumTargetType: 'downloadBasicInfo',
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'editionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'text',
        children: [
          {
            enumKey: 'isEditionAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'mobileDateSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        msgKey: 'dbi_info_mobile_time_settings_info',
        msgCondition: '!additionalFields:businessType:mobile-retention',
        children: [
          {
            isDefault: true,
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'special_dateSettingsByTime',
        enumTargetType: 'downloadMainCategory',
        // 这里的condition要特别注意，subForm的层级要在自己的form中重新开始
        condition: 'mobileDateSettings:separate',
        type: 'checkboxGroup',
        children: [
          {
            enumKey: 'daily',
            enumTargetType: 'granularity',
            defaultSelectCondition: 'additionalFields:dateType:daily',
            disableCondition: 'additionalFields:businessType:mobile-retention',
          },
          {
            enumKey: 'weekly',
            enumTargetType: 'granularity',
            defaultSelectCondition: 'additionalFields:dateType:weekly',
            disableCondition: 'additionalFields:businessType:mobile-retention',
          },
          {
            enumKey: 'monthly',
            enumTargetType: 'granularity',
            defaultSelectCondition: 'additionalFields:dateType:monthly',
          },
        ],
      },
      {
        enumKey: 'regionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            isDefault: true,
            enumKey: 'isCountryAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isByCountries',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isByRegion',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        condition: '!additionalFields:businessType:mobile-rpd',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        defaultSelectCondition:
          'additionalFields:businessType:mobile-retention||additionalFields:businessType:mobile-databrain',
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
        defaultSelectCondition:
          '!additionalFields:businessType:mobile-retention&&!additionalFields:businessType:mobile-databrain',
      },
      {
        enumKey: 'exportSelected',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const MOBILE_NEW_GAME_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'hasCompany',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasGenre',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasRelease',
        enumTargetType: 'downloadBasicInfo',
        condition: 'additionalFields:businessType:mobile-newRelease',
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        defaultSelectCondition: 'additionalFields:businessType:mobile-newRelease',
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
        defaultSelectCondition: 'additionalFields:businessType:mobile-upcoming',
      },
      {
        enumKey: 'exportSelected',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const MOBILE_DEMOGRAPHICS_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'overlapMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    isShowOneText: true,
    children: [
      {
        label: 'MAU',
        labelKey: 'dbi_mau',
        isDefault: true,
        value: 'mau',
      },
      {
        label: 'Demographics',
        labelKey: 'dbi_demographics',
        value: 'demographics',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'hasCompany',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasGenre',
        enumTargetType: 'downloadBasicInfo',
      },
      {
        enumKey: 'hasRelease',
        enumTargetType: 'downloadBasicInfo',
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        label: 'Platform Settings',
        labelKey: 'dbi_label_platform_settings',
        value: 'platform',
        type: 'checkboxGroup',
        children: [
          {
            label: 'IOS',
            labelKey: '',
            value: 'appstore',
            isDefault: true,
          },
          {
            label: 'Google Play',
            labelKey: '',
            value: 'googleplay',
            isDefault: true,
          },
        ],
      },
      {
        enumKey: 'timePickerSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'datePicker',
        msgKey: 'dbi_info_mobile_demographics_download_time_setting_info',
      },
      {
        label: 'Country Settings',
        labelKey: 'dbi_label_country_settings',
        value: 'countrySettings',
        type: 'mutipleCountry',
        msgKey: 'dbi_info_mobile_demographics_countries_time_setting_info',
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        condition: '!additionalFields:businessType:mobile-rpd',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

export default {
  mobileUniversal: MOBILE_UNIVERSAL_DOWNLOAD_SET,
  mobileNewGame: MOBILE_NEW_GAME_DOWNLOAD_SET,
  mobileDemographics: MOBILE_DEMOGRAPHICS_DOWNLOAD_SET,
};
